import angular from 'angular';
import ComponentsModule from '../components-module';

const COMPONENT_NAME = 'CodeTranslateLoader';

angular.module (ComponentsModule)
  .factory (COMPONENT_NAME, (LocalizationService, ApplicationConfigurationService, ErrorMessagingService) => {
    return (options) => {
      return ApplicationConfigurationService.getConfigurationFor('i18n', {})
        .then (({ localizationContexts }) => {
          localizationContexts = localizationContexts || ['ace-ui', 'code'];

          return LocalizationService.getLocalization({ localizationContexts, languageKey: options.key })
            .then ((resp) => { return resp; })
            .catch ((error) => {
              if (error.type !== atex.aceui.error.types.NOT_FOUND) {
                ErrorMessagingService.sendError(atex.aceui.error.Error({
                  type: atex.aceui.error.types.REQUEST_FAILED,
                  severity: atex.aceui.error.severities.MAJOR,
                  origin: COMPONENT_NAME,
                  cause: 'Could not download from the localization service: Language not downloaded.',
                  rootCause: error
                }));
              }

              return {};
            });
        })
        .catch ((error) => {
          ErrorMessagingService.sendError(atex.aceui.error.Error({
            type: atex.aceui.error.types.CONFIG_ERROR,
            severity: atex.aceui.error.severities.MAJOR,
            origin: COMPONENT_NAME,
            cause: 'Could not read configuration for LocalizationService.',
            rootCause: error
          }));
        });
    };
  });

export default COMPONENT_NAME;
